import axios from "axios";

/* -------------------------------------------------------
   SAFE API BASE
   Works on:
   - localhost
   - production VPS
   - mobile webview
------------------------------------------------------- */

const API_BASE =
  (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

/* -------------------------------------------------------
   AXIOS INSTANCE
------------------------------------------------------- */

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000
});

/* -------------------------------------------------------
   AUTH TOKEN INTERCEPTOR
------------------------------------------------------- */

api.interceptors.request.use((cfg) => {

  const candidateToken = localStorage.getItem("candidateToken");
  const adminToken = localStorage.getItem("token");

  const token = candidateToken || adminToken;

  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }

  return cfg;
});

/* -------------------------------------------------------
   RESPONSE ERROR HANDLER (optional safety)
------------------------------------------------------- */

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      console.warn("Unauthorized request");
    }
    return Promise.reject(error);
  }
);

export default api;